import { useNavigate } from "react-router-dom";
import apiPaths from "../../../../../api/endpoints";
import { RoomProps, TabType } from "../../types";
import { webRoutes } from "../../../../router/webRoutes";
import ChatBubble from "../ChatBubble/ChatBubble";
import YetiCharacter from "../YetiCharacter/YetiCharacter";
import Snowfall from "../Snowfall/Snowfall";
// import questImgSrc from "../../../../appAssets/homeTemplate/yardTempImg/questImg.png";
import "./YardRoom.scss";
import floatingPlaneJson from "../../../../appAssets/jsons/floatingPlane.json";
import questRoomIcon from "../../../../appAssets/jsons/questRoomIcon.json";
import clickAnimationJson from "../../../../appAssets/jsons/ClickAnimation.json";
import Lottie from "lottie-react";
import { useCallback, useEffect, useState } from "react";
import InputContainer from "../../../WebStoryScreen/Components/InputContainer";
import WebLottiePlayer from "../../../WebStoryScreen/Components/WebLottiePlayer";
import HobbySelector from "../HobbySelector/HobbySelector";
import {
  ExtractNameFromUrl,
  getMatchingObjectNames,
} from "../../../../Utilities/utilFunctions";
import { trackEvent } from "../../../../../mixpanel";
import { TrackingEvents } from "../../../../Utilities/analytics";

function YardRoom({
  storyData,
  activeBlock,
  conversationIndex,
  objectIndex,
  onTabChange,
  onNavigateToJourney,
  onInputSubmit,
  onTemplateSubmit,
  onButtonAction,
  onTapIndicator,
}: RoomProps) {
  const isOnboardingDone = storyData?.isOnboardingCompleted ?? false;
  const yetiOnLeft = isOnboardingDone || (activeBlock?.order ?? 1) > 2;
  const navigate = useNavigate();
  const [showInputText, setShowInputText] = useState({
    state: false,
    textValue: "",
  });
  // const [storyData, setConvoDataList] = useState(storyData);
  const [enableHobbySelected, setEnableHobbySelected] = useState(false);
  const [showButtonType, setShowButtonType] = useState({
    state: false,
    textValue: "",
  });
  const [displayHomeObject, setDisplayHomeObject] = useState({
    url: "",
    name: "",
    tapindicator: "",
  });
  const [tapIndicatorName, setTapIndicatorName] = useState<string | null>(null);

  const returnObjectRendering = useCallback(
    (arg0: { name: string; url: string; tapIndicator: string }) => {
      setTapIndicatorName(arg0.tapIndicator);
      onTapIndicator?.(arg0.tapIndicator);
    },
    [onTapIndicator],
  );
  // Each room always uses its own fixed CDN background (mirrors mobile post-onboarding)
  // bgImageTab from activeBlock is intentionally NOT used — same block would make all tabs identical
  const bgUrl = require("../../../../appAssets/outdoorRoom.png");
  // const bgUrl = apiPaths.YARDROOM_TEMPLATE_TAB;

  useEffect(() => {
    if (!storyData?.blocks?.[0]?.conversations) return;
    const conversations = storyData.blocks[0].conversations;
    const currentConversation = conversations[conversationIndex]?.object || [];
    const isLastConversation = conversationIndex === conversations.length - 1;
    const isLastObject = objectIndex === currentConversation.length - 1;
    const tapIndicator =
      storyData?.blocks?.[0]?.conversations?.[conversationIndex]?.object[0]
        .tapIndicator;

    if (tapIndicator) {
      returnObjectRendering({
        name: tapIndicator,
        url: "",
        tapIndicator: tapIndicator,
      });
    }

    // If not at the last object, increment objectIndex after timeout
    if (objectIndex < currentConversation.length - 1) {
      if (currentConversation[objectIndex]?.templateElements) {
        setEnableHobbySelected(true);
      }

      // const timer = setTimeout(
      //   () => {
      //     setObjectIndex((prev) => prev + 1);
      //   },
      //   parseInt(currentConversation[objectIndex]?.duration || "5000") +
      //     conversationBufferDuration,
      // );

      // return () => clearTimeout(timer);
    }

    if (isLastConversation && isLastObject) {
      if (
        storyData?.blocks?.[0]?.conversations?.[conversationIndex]?.object[
          objectIndex
        ]?.templateElements
      ) {
        setEnableHobbySelected(true);
      }
      // Do NOT increment any further, so the last block stays visible
      storyData?.blocks?.[0]?.userActions?.map(
        (action: { component: string; buttonText: string }) => {
          if (action?.component?.toLowerCase() === "block.text-input") {
            setShowInputText({ state: true, textValue: action.buttonText });
          }
          if (
            action?.component?.toLowerCase() === "block.button-input" &&
            !storyData?.blocks?.[0]?.conversations?.[conversationIndex]?.object[
              objectIndex
            ]?.templateElements
          ) {
            setShowButtonType({ state: true, textValue: action.buttonText });
          }
        },
      );
    }
  }, [conversationIndex, objectIndex, storyData, returnObjectRendering]);

  const currentObject =
    activeBlock?.conversations?.[conversationIndex]?.object?.[objectIndex] ??
    null;

  const handleSubmit = (value: string) => {
    onInputSubmit?.(value);
  };

  const handleObjectClick = (objectName: string, route: string) => {
    navigate(route);
  };

  const userActions = activeBlock?.userActions ?? [];
  const conversationsExhausted =
    (activeBlock?.conversations?.length ?? 0) > 0 &&
    conversationIndex >= (activeBlock?.conversations?.length ?? 0);

  useEffect(() => {
    const blockObjects =
      storyData?.blocks?.[0]?.conversations?.[conversationIndex]?.object[0]
        .blockObjects ?? [];
    const normalizedBlockObjects = blockObjects.map(
      (obj: { name: string; url: string; linkTo?: string }) => ({
        ...obj,
        linkTo: obj.linkTo ?? obj.url,
      }),
    );
    const homeObject = ExtractNameFromUrl(normalizedBlockObjects);
    if (homeObject) {
      const homeObjectName = Array.isArray(homeObject)
        ? homeObject[0]?.name
        : homeObject?.name;
      const homeExist = getMatchingObjectNames(
        homeObjectName ? [homeObjectName] : [],
        normalizedBlockObjects,
      );

      const tapIndicator =
        storyData?.blocks?.[0]?.conversations?.[conversationIndex]?.object[0]
          .tapIndicator;

      if (homeExist && displayHomeObject.url !== homeExist[0]?.url) {
        setDisplayHomeObject({
          url: homeExist[0]?.url ?? "",
          name: homeExist[0]?.name ?? "",
          tapindicator: tapIndicator ?? "",
        });
      }
    }
  }, [currentObject]);

  return (
    <div
      className="yard-room"
      style={{
        backgroundImage: `url(${require("../../../../appAssets/outdoor-nohousebench-web.png")})`,
      }}
    >
      {/* Snowfall — matches mobile: <Snowfall duration={6000} maxSize={10} /> */}
      <Snowfall duration={6000} maxSize={10} />

      {/* Tap indicator — rendered per known target; add new modifier classes for future targets */}
      {tapIndicatorName === "MusicIcon" && (
        <div className="yard-room__tap-indicator yard-room__tap-indicator--music">
          <Lottie
            animationData={clickAnimationJson}
            loop
            autoplay
            className="yard-room__tap-indicator-lottie"
          />
        </div>
      )}

      {/* Input container — LEFT side, shown when text-input userAction is active */}
      {showInputText.state && (
        <div className="yard-room__input">
          <InputContainer
            updateInputValue={(value) => {
              // setConversationIndex(0);
              // setObjectIndex(0);
              handleSubmit(value);
              setShowInputText({ textValue: "", state: false });
            }}
          />
        </div>
      )}
      {/* Hobby selector — LEFT side, shown when templateElements are present */}
      {enableHobbySelected && currentObject?.templateElements && (
        <div className="yard-room__input">
          <HobbySelector
            items={storyData?.blocks?.[0]?.templateObjects ?? []}
            onSubmit={(selected) => {
              setEnableHobbySelected(false);
              onTemplateSubmit?.(selected);
            }}
          />
        </div>
      )}

      {/* Yeti — right by default, left when order > 2 */}
      <div
        className={`yard-room__yeti${yetiOnLeft ? " yard-room__yeti--left" : ""}`}
      >
        <YetiCharacter
          characterImage={currentObject?.characterImage}
          className="yard-room__yeti-lottie"
        />
      </div>

      {/* Chat bubble — shifts and flips tail when yeti moves left */}
      {currentObject?.content?.trim() && (
        <div
          className={`yard-room__bubble${yetiOnLeft ? " yard-room__bubble--yeti-left" : ""}`}
        >
          <ChatBubble
            content={currentObject.content}
            textColor={currentObject.textColor}
            tailSide={yetiOnLeft ? "left" : "right"}
            audioUri={currentObject.audio}
          />
        </div>
      )}

      {/* Quest object — bottom-right (mobile: navigates to QuestScreen) */}
      {isOnboardingDone && (
        <button
          type="button"
          className="home-room__obj  yard-room__quest"
          onClick={() => {
            console.log("object_clicked: quest from: outdoor");
            trackEvent(TrackingEvents.object_clicked, {
              object_name: "quest",
              from: "yard",
            });
            navigate(webRoutes.questScreen);
          }}
          aria-label="Quest"
        >
          <Lottie
            animationData={questRoomIcon}
            loop
            autoplay
            className="yard-room__quest-img"
          />
          {/* <img src={questImgSrc} alt="Quest" className="yard-room__quest-img" /> */}
        </button>
      )}
      {/* Home button — switches active tab to HomeRoom (Indoor) */}
      {isOnboardingDone && (
        <button
          type="button"
          className="yard-room__homebtn-wrap"
          onClick={() => {
            console.log("object_clicked: home from: outdoor");
            onTabChange?.(TabType.Indoor);
          }}
          aria-label="Go to Home Room"
        >
          <img
            src={require("../../../../appAssets/homeBtn.png")}
            alt=""
            className="yard-room__homebtn"
          />
        </button>
      )}
      {displayHomeObject?.url && (
        <button
          type="button"
          className="yard-room__homebtn-wrap"
          onClick={() => {
            trackEvent(TrackingEvents.introduction_completed, {
              type: "home",
            });
            setShowButtonType({ state: false, textValue: "" });
            setTapIndicatorName(null);
            onButtonAction?.();
          }}
        >
          <WebLottiePlayer
            source={displayHomeObject.url}
            className="yard-room__homebtn"
            loop
            autoPlay
          />
          {displayHomeObject?.name === "Home" &&
            tapIndicatorName === "Home" && (
              <div className="yard-room__homebtn-indicator">
                <Lottie
                  animationData={clickAnimationJson}
                  loop
                  autoplay
                  className="yard-room__tap-indicator-lottie"
                />
              </div>
            )}
        </button>
      )}

      {isOnboardingDone && (
        <button
          className="home-room__obj yard-room__obj--balloon"
          // onClick={() => handleObjectClick("my journey", webRoutes.journey)}
          onClick={() => {
            trackEvent(TrackingEvents.object_clicked, {
              object_name: "my journey",
              from: "home",
            });
            onNavigateToJourney?.();
          }}
          aria-label="My Journey"
        >
          <Lottie
            animationData={floatingPlaneJson}
            loop
            autoplay
            className="home-room__obj-lottie"
          />
        </button>
      )}

      {/* User action buttons */}
      {conversationsExhausted && userActions.length > 0 && (
        <div className="yard-room__actions">
          {userActions.map((action, i) => (
            <button key={i} className="yard-room__action-btn">
              {action.buttonText}
            </button>
          ))}
        </div>
      )}

      {/* Button-input action — bottom-center, onboarding only */}
      {!isOnboardingDone &&
        (showButtonType.state ||
          (displayHomeObject?.name === "Home" &&
            tapIndicatorName === "Home")) && (
          <div className="yard-room__bottom-action">
            <button
              type="button"
              className="yard-room__bottom-btn"
              onClick={() => {
                if (
                  displayHomeObject?.name === "Home" &&
                  tapIndicatorName === "Home"
                ) {
                  trackEvent(TrackingEvents.introduction_completed, {
                    type: "home",
                  });
                }
                setShowButtonType({ state: false, textValue: "" });
                setTapIndicatorName(null);
                onButtonAction?.();
              }}
            >
              {showButtonType.textValue || "Continue"}
            </button>
          </div>
        )}
    </div>
  );
}

export default YardRoom;
